<template>
  <div class="login">
    <div class="header">
      <div class="logo">
        <img src="../static/headlogo.png" alt="" />
        <p>{{ $t("login.title") }}</p>
      </div>
      <div class="logo2">
        <img src="../static/title_logo.png" />
      </div>
    </div>
    <div class="loginfrom">
      <div class="exit">
        <p @click="goHome()" style="cursor: pointer">
          <i class="el-icon-arrow-left"></i>{{ $t("login.goback") }}
        </p>
        <p @click="changeLang()">
          {{ lang == "zh" ? $t("login.en") : $t("login.zh") }}
        </p>
      </div>
      <div class="title">
        <h3>{{ $t("login.welcome") }}</h3>
        <p>{{ $t("login.content") }}</p>

        <el-form
          ref="form"
          class="form"
          :model="sizeForm"
          :rules="loginRules"
          label-width=""
          size="mini"
        >
          <el-form-item label="" prop="username">
            <el-input
              :placeholder="$t('login.placeholder1')"
              prefix-icon="el-icon-user"
              v-model="sizeForm.username"
            >
            </el-input>
          </el-form-item>

          <el-form-item label="" prop="password">
            <el-input
              :placeholder="$t('login.placeholder2')"
              prefix-icon="el-icon-lock"
              v-model="sizeForm.password"
              show-password
            >
            </el-input>
          </el-form-item>

          <el-checkbox v-model="checked">
            <div class="agree">
              <div class="a">
                {{ $t("login.agree") }}
                <div @click="agreement1" class="agreement">
                  {{ $t("login.privacyStatement") }}
                </div>
              </div>

              <div class="b" @click="reset1()">
                {{ $t("login.forgetPassword") }}
              </div>
            </div>
          </el-checkbox>

          <el-button
            type="primary"
            class="button"
            @click="submitForm(sizeForm)"
            >{{ $t("login.loginNow") }}</el-button
          >
        </el-form>
        <p>
          {{ $t("login.clickTip")
          }}<span
            ><span @click="goRegist()"> {{ $t("login.register") }}</span></span
          ><span>{{ $t("login.registerInfo") }}</span>
        </p>
        <div class="regist" @click="goRegist()">
          {{ $t("login.visitRegistration") }}
        </div>
      </div>
    </div>
    <div class="alert" v-if="agreement">
      <i class="el-icon-close" @click="close"></i>
      <h3>{{ $t("privacy.title") }}</h3>
      <p style="color: #333; font-weight: normal">
        {{ $t("privacy.statement") }}
      </p>
      <div class="wenzhang1">
        <p
          style="
            text-align: left;
            font-size: 15px;
            font-weight: bold;
            text-indent: 0em;
            margin-top: 5px;
          "
        >
          {{ $t("privacy.tip1.title") }}
        </p>
        <p style="color: #333">
          {{ $t("privacy.tip1.info1") }}
        </p>
        <p style="color: #333">
          {{ $t("privacy.tip1.info2") }}
        </p>
        <p style="color: #333">
          {{ $t("privacy.tip1.info3") }}
        </p>
      </div>
      <p
        style="
          text-align: left;
          font-size: 15px;
          font-weight: bold;
          text-indent: 0em;
        "
      >
        {{ $t("privacy.tip2.title") }}
      </p>
      <p
        style="
          text-align: left;
          font-size: 15px;
          font-weight: bold;
          text-indent: 0em;
        "
      >
        {{ $t("privacy.tip2.info1") }}
      </p>
      <p style="font-size: 15px">{{ $t("privacy.tip2.info2") }}</p>
      <p style="font-size: 15px">{{ $t("privacy.tip2.info3") }}</p>
      <p style="font-size: 15px">{{ $t("privacy.tip2.info4") }}</p>
      <p style="font-size: 15px">
        {{ $t("privacy.tip2.info5") }}
      </p>
      <p style="font-size: 15px">
        {{ $t("privacy.tip2.info6") }}
      </p>
      <p style="font-size: 15px">
        {{ $t("privacy.tip2.info7") }}
      </p>
      <p style="color: #333">
        {{ $t("privacy.tip2.info8") }}
      </p>
      <p style="color: #333">
        {{ $t("privacy.tip2.info9") }}
      </p>
      <p style="color: #333">
        {{ $t("privacy.tip2.info10") }}
      </p>
      <p
        style="
          text-align: left;
          font-size: 15px;
          font-weight: bold;
          text-indent: 0em;
        "
      >
        {{ $t("privacy.tip3.title") }}
      </p>
      <p style="color: #333">
        {{ $t("privacy.tip3.info1") }}
      </p>
      <p style="color: #333">
        {{ $t("privacy.tip3.info2") }}
      </p>
      <p
        style="
          text-align: left;
          font-size: 15px;
          font-weight: bold;
          text-indent: 0em;
        "
      >
        {{ $t("privacy.tip4.title") }}
      </p>
      <p style="color: #333">
        {{ $t("privacy.tip4.info1") }}
      </p>
      <p
        style="
          text-align: left;
          font-size: 15px;
          font-weight: bold;
          text-indent: 0em;
        "
      >
        {{ $t("privacy.tip5.title") }}
      </p>
      <p style="color: #333">
        {{ $t("privacy.tip5.info1") }}
      </p>
      <p style="color: #333">
        {{ $t("privacy.tip5.info2") }}
      </p>
      <p style="color: #333">
        {{ $t("privacy.tip5.info3") }}
      </p>
      <p style="color: #333">
        {{ $t("privacy.tip5.info4") }}
      </p>
      <p
        style="
          text-align: left;
          font-size: 15px;
          font-weight: bold;
          text-indent: 0em;
        "
      >
        {{ $t("privacy.tip6.title") }}
      </p>
      <p style="color: #333">
        {{ $t("privacy.tip6.info1") }}
      </p>
      <p
        style="
          text-align: left;
          font-size: 15px;
          font-weight: bold;
          text-indent: 0em;
        "
      >
        {{ $t("privacy.tip7.title") }}
      </p>
      <p style="color: #333">
        {{ $t("privacy.tip7.info1") }}
      </p>
      <p style="color: #333">
        {{ $t("privacy.tip7.info2") }}
      </p>
      <p style="color: #333">
        {{ $t("privacy.tip7.info3") }}
      </p>
      <p
        style="
          text-align: left;
          font-size: 15px;
          font-weight: bold;
          text-indent: 0em;
        "
      >
        {{ $t("privacy.tip8.title") }}
      </p>
      <p style="color: #333">
        {{ $t("privacy.tip8.info1") }}
      </p>
      <p style="color: #333">
        {{ $t("privacy.tip8.info2") }}
      </p>
      <p
        style="
          text-align: left;
          font-size: 15px;
          font-weight: bold;
          text-indent: 0em;
        "
      >
        {{ $t("privacy.tip9.title") }}
      </p>
      <p style="color: #333">
        {{ $t("privacy.tip9.info1") }}
      </p>
      <p style="color: #333">
        {{ $t("privacy.tip9.info2") }}
      </p>
      <p style="color: #333">
        {{ $t("privacy.tip9.info3") }}
      </p>
      <p
        style="
          text-align: left;
          font-size: 15px;
          font-weight: bold;
          text-indent: 0em;
        "
      >
        {{ $t("privacy.tip10.title") }}
      </p>
      <p style="color: #333">
        {{ $t("privacy.tip10.info1") }}
      </p>
    </div>

    <el-dialog
      :title="$t('login.reset.title')"
      :visible.sync="dialogVisible"
      :width="lang == 'zh' ? '460px' : '600px'"
      :before-close="handleClose"
      :close-on-click-modal="false"
      style="margin-top: 15vh"
    >
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        :label-width="lang == 'zh' ? '110px' : '200px'"
        class="demo-ruleForm"
      >
        <el-form-item :label="$t('login.reset.label1')" prop="phone">
          <el-input
            v-model="ruleForm.phone"
            :placeholder="$t('login.reset.placeholder1')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('login.reset.label2')" prop="code">
          <el-input
            v-model="ruleForm.code"
            :placeholder="$t('login.reset.placeholder2')"
            style="float: left"
          ></el-input>
          <el-button @click="sendPhone()" :disabled="timer !== 0"
            >{{ $t("login.reset.sendCode")
            }}<span v-if="timer !== 0">{{ timer }}</span></el-button
          >
        </el-form-item>
        <el-form-item :label="$t('login.reset.label3')" prop="password">
          <el-input
            v-model="ruleForm.password"
            type="password"
            :placeholder="$t('login.reset.placeholder3')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('login.reset.label4')" prop="newPassword">
          <el-input
            v-model="ruleForm.newPassword"
            type="password"
            :placeholder="$t('login.reset.placeholder4')"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="resetSave()">{{
          $t("common.save")
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="$t('common.tip')"
      :visible.sync="tipVisiable"
      width="460px"
      :before-close="handleClose1"
      :close-on-click-modal="false"
      style="margin-top: 15vh"
    >
      <span>{{ tip }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="tipVisiable = false">{{
          $t("common.sure")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { login, resetPassword, sendCode } from "../../api/login.js";
import { backFront, regist } from "../../utils/common.js";

export default {
  data() {
    var validatorPassword = (rule, value, callback) => {
      const string = this.ruleForm.password;
      if (string !== value) {
        callback(new Error(this.$t("login.validatorInfo")));
      } else {
        callback();
      }
    };
    return {
      regist: regist(),
      backFront: backFront(),
      sizeForm: {
        username: "",
        password: "",
      },
      checked: false,
      agreement: false,
      dialogVisible: false,
      ruleForm: {},
      rules: {
        phone: [
          {
            required: true,
            message: this.$t("common.rules.phone"),
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: this.$t("login.rules.code"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("common.rules.newPassword"),
            trigger: "blur",
          },
        ],
        newPassword: [
          {
            required: true,
            message: this.$t("common.rules.confirmPassword"),
            trigger: "blur",
          },
          { validator: validatorPassword },
        ],
      },
      loginRules: {
        username: [
          {
            required: true,
            message: this.$t("common.rules.phone"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("login.rules.password"),
            trigger: "blur",
          },
        ],
      },
      timer: 0,
      tipVisiable: false,
      tip: "",
      redirectUrl: "",
      lang: "zh",

      userInfo: {}, //存储用户信息
    };
  },
  created() {
    const lang = localStorage.getItem("lang");
    this.$i18n.locale = lang ? lang : "zh";
    this.lang = lang ? lang : "zh";
  },
  methods: {
    changeLang() {
      if (this.lang == "zh") {
        localStorage.setItem("lang", "en");
        this.$i18n.locale = "en";
        this.lang = "en";
      } else if (this.lang == "en") {
        localStorage.setItem("lang", "zh");
        this.$i18n.locale = "zh";
        this.lang = "zh";
      }
      window.location.reload();
    },
    getQueryString(query) {
      const obj = this.$router.history.current.query;
      if (obj[query]) {
        return obj[query];
      } else {
        return "";
      }
    },
    goHome() {
      window.location.href = this.backFront;
    },
    goRegist() {
      window.location.href = this.regist;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleClose1() {
      this.tipVisiable = false;
    },
    async sendPhone() {
      const params = {
        phone: this.ruleForm.phone,
      };
      try {
        const { data } = await sendCode(params);
        if (data.code === 200) {
          this.$message.success(this.$t("login.messages.code"));
          this.timer = 59;
          let timeInterVal = setInterval(() => {
            if (this.timer <= 0) {
              clearInterval(timeInterVal);
              this.timer = 0;
            }
            --this.timer;
          }, 1000);
        } else {
          this.$message.error(err.msg);
        }
      } catch (err) {
        this.$message.error(err.msg);
      }
    },
    async reset() {
      try {
        const { data } = await resetPassword(this.ruleForm);
        if (data.code === 200) {
          this.dialogVisible = false;
          this.sizeForm = {
            username: this.ruleForm.phone,
            password: this.ruleForm.password,
          };
          // 重置成功
          this.tipVisiable = true;
          this.tip = this.$t("login.messages.success");
        } else {
          // 重置失败
          this.tipVisiable = true;
          this.tip = this.$t("login.messages.fail");
        }
      } catch (err) {
        console.log(err.message);
      }
    },
    resetSave() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.reset();
        } else {
          this.$message.error(this.$t("common.require"));
        }
      });
    },
    reset1() {
      this.dialogVisible = true;
    },
    async submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.login();
        }
      });
    },
    async login() {
      try {
        let Base64 = require("js-base64").Base64;
        let formdata = {
          username: "",
          password: "",
        };
        formdata.username = Base64.encode(this.sizeForm.username);
        formdata.password = Base64.encode(this.sizeForm.password);
        // const params
        //  = this.sizeForm;

        const { data } = await login(formdata);
        if (!this.checked) {
          this.$message.error(this.$t("login.messages.loginError1"));
        } else if (this.checked && data.code == 200) {
          this.$message({
            message: this.$t("login.messages.loginSuccess"),
            type: "success",
          });
          const redirectUrl = this.getQueryString("redirectUrl");
          // this.$router.push("/backIndex/homeIndex");
          if (redirectUrl) {
            window.location.href =
              this.backFront +
              "?viewToken=" +
              data.data.token +
              "&redirectUrl=" +
              encodeURIComponent(redirectUrl);
          } else {
            window.location.href =
              this.backFront + "?viewToken=" + data.data.token;
          }
          localStorage.removeItem("audienceInfo"); //清除缓存
          localStorage.setItem(
            "audienceInfo",
            JSON.stringify(data.data.userInfo)
          ); //存储观众信息
          this.userInfo = { ...data.data.userInfo }; //将用户数据存储起来
          localStorage.setItem("viewToken", data.data.token);
        } else {
          this.$message.error(this.$t("login.messages.loginError2"));
        }
      } catch (error) {
        console.log(error);
      }
    },
    agreement1() {
      this.agreement = true;
    },
    close() {
      this.agreement = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100vh !important;
  box-sizing: border-box;
  position: relative;
  background: url("../static/logobj.png") no-repeat;
  background-size: 100%;

  .header {
    display: flex;
    justify-content: space-between;
    padding: 0px 53px;
    margin-bottom: 54px;
    padding-top: 41px;
    box-sizing: border-box;
    .logo {
      width: 616px;
      height: 150px;

      p {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 25px;
        margin-left: 98px;
        margin-top: 18px;
      }
      img {
        width: 616px;
        height: 114px;
      }
    }
    .logo2 {
      img {
        width: 161px;
        height: 40px;
      }
    }
  }

  .loginfrom {
    width: 490px;
    height: 612px;
    background: rgba(255, 255, 255, 0.88);
    box-shadow: 0px 5px 7px 0px rgba(139, 139, 139, 0.5);
    border-radius: 12px;
    border: 1px solid;
    margin: 0 auto;
    padding: 44px 70px;
    box-sizing: border-box;
    p {
      margin-top: 20px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 22px;
    }
    span {
      color: #006fb8;
      cursor: pointer;
    }
    span:nth-child(2) {
      color: #666666;
    }
    .regist {
      margin-top: 30px;
      width: 350px;
      height: 40px;
      border-radius: 4px;
      border: 1px solid #006fb8;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #006fb8;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
    }
    .exit {
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      margin-bottom: 36px;
      cursor: pointer;
    }
    .title {
      h3 {
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #006fb8;
        margin-bottom: 18px;
      }
    }
    .form {
      margin: 0 auto;
      width: 350px;
      margin-top: 44px;
      span {
        color: #006fb8;
      }
      .button {
        width: 350px;
        height: 35px;
        background: #006fb8;
        margin-top: 44px;
      }
    }
  }
  .alert {
    width: 980px;
    height: 697px;
    overflow: auto;

    // border: 1px solid red;
    position: absolute;
    top: 120px;
    left: 343px;
    background: white;
    box-sizing: border-box;
    padding: 0 26px 26px 26px;
    z-index: 999;
    i {
      position: absolute;
      top: 5px;
      right: 5px;
      cursor: pointer;
    }
    h3 {
      font-size: 26px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 37px;
      margin-bottom: 26px;
      text-align: center;
      margin-top: 61px;
    }
    h5 {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 22px;
      margin-bottom: 17px;
      text-align: center;
    }
    p {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 21px;
      text-indent: 2rem;
    }
    .wenzhang1 {
      margin-bottom: 26px;
    }
    .el-icon-close {
      float: right;
    }
  }
}
</style>
<style scoped>
.form >>> .el-input__inner {
  height: 35px;
}
.el-dialog {
  width: 460px;
}
.el-dialog__wrapper >>> .el-dialog__header {
  height: 44px;
  background: #006fb8;
  border-radius: 2px 2px 0px 0px;
  padding: 10px 30px;
  box-sizing: border-box;
}
.el-dialog__wrapper >>> .el-dialog__headerbtn {
  top: 15px;
}

.el-dialog__wrapper >>> .el-dialog__title {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 24px;
}
.el-dialog__wrapper >>> .el-dialog__close {
  color: #fff;
}
.dialog-footer >>> .el-button--primary {
  width: 65px;
  height: 32px;
  background: #006fb8;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 22px;
  padding: 0px;
}
.el-dialog__wrapper >>> .el-dialog__footer {
  border-top: 1px solid rgba(0, 0, 0, 0.09);
  padding: 10px 30px 10px;
  box-sizing: border-box;
}
.el-dialog__wrapper >>> .el-input__inner {
  height: 32px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.15);
}

.el-form >>> .el-button {
  height: 32px;
  background: #006fb8;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  /* line-height: 32px; */
  float: right;
  text-align: center;
  margin-top: 4px;
  cursor: pointer;
  padding: 5px;
  box-sizing: border-box;
}
.el-button.is-disabled,
.el-button.is-disabled:focus,
.el-button.is-disabled:hover {
  color: #c0c4cc;
  cursor: not-allowed;
  background-image: none;
  background-color: #fff;
  border-color: #ebeef5;
}
.el-dialog__wrapper
  .demo-ruleForm
  .el-form-item:nth-child(2)
  >>> .el-input__inner {
  width: 190px;
}
.el-dialog__wrapper .demo-ruleForm .el-form-item:nth-child(2) >>> .el-input {
  width: 190px;
}
.agree {
  width: 325px;
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #006fb8;
}
.agree .agreement {
  font-size: 12px;
  color: #006fb8;
}
.agree >>> .a {
  width: 220px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 17px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.agree >>> .b {
  flex: 1;
  text-align: right;
}
</style>
